import { Menu, Newspaper, Shield, ShieldCheck } from 'lucide-react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { useClickOutside } from '../hooks/useClickOutside.js';
import { useAuth } from '../context/AuthContext.js';
import './NavMenu.css';

/**
 * The whole site's navigation, collapsed into one dropdown at every screen
 * size — there's only ever three destinations, so a permanent link row (or
 * a separate mobile tab bar) was more chrome than the app needs.
 */
export function NavMenu() {
  const { t } = useTranslation();
  const { isAuthenticated, user } = useAuth();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useClickOutside(menuRef, () => setOpen(false));

  return (
    <div className="nav-menu" ref={menuRef}>
      <button
        type="button"
        className="nav-menu-trigger"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Menu size={18} />
        <span className="nav-menu-trigger-label">{t('common.appName')}</span>
      </button>

      {open && (
        <nav className="nav-menu-panel" role="menu">
          <NavLink
            to="/"
            end
            className={({ isActive }) => `nav-menu-item ${isActive ? 'nav-menu-item-active' : ''}`}
            onClick={() => setOpen(false)}
          >
            <Shield size={16} /> {t('nav.roster')}
          </NavLink>
          {isAuthenticated && (
            <NavLink
              to="/feed"
              className={({ isActive }) =>
                `nav-menu-item ${isActive ? 'nav-menu-item-active' : ''}`
              }
              onClick={() => setOpen(false)}
            >
              <Newspaper size={16} /> {t('nav.feed')}
            </NavLink>
          )}
          {user?.role === 'admin' && (
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                `nav-menu-item ${isActive ? 'nav-menu-item-active' : ''}`
              }
              onClick={() => setOpen(false)}
            >
              <ShieldCheck size={16} /> {t('nav.admin')}
            </NavLink>
          )}
        </nav>
      )}
    </div>
  );
}
